import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, usersApi } from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setAuthError } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code  = params.get("code");
    const state = params.get("state");
    const error = params.get("error");

    if (error || !code) {
      setAuthError(error || "error");
      navigate("/", { replace: true });
      return;
    }

    authApi.exchangeCode(code, state)
      .then(async (data) => {
        localStorage.setItem("access_token", data.access_token);
        const user = await usersApi.me();
        setUser(user);
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail;
        const key =
          detail === "access_denied_domain"           ? "domain"
          : detail === "access_denied_not_authorized" ? "not_authorized"
          : detail === "access_denied_inactive"       ? "inactive"
          : "error";
        setAuthError(key);
        navigate("/", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600" />
    </div>
  );
}
